<template>
  <b-row>
    <!-- Importacion de empleados -->
    <b-col
      cols="12"
      lg="4"
      md="4"
      sm="6"
    >
      <BlockCard
        button="Importar"
        description="Importar empleados desde un archivo .csv"
        title="Importación de empleados"
        icon="UsersIcon"
        @action="importEmpleados = true"
      />
    </b-col>
    <importar-empleados
      :show="importEmpleados"
      @closeModal="importEmpleados = false"
    />

    <!-- Variables de entorno -->
    <b-col
      cols="12"
      lg="4"
      md="4"
      sm="6"
    >
      <BlockCard
        button="Configurar"
        description="Configurar las variables de entorno utilizadas en el sitio web"
        title="Variables de entorno"
        icon="SettingsIcon"
      />
    </b-col>

    <b-col
      cols="12"
      lg="4"
      md="4"
      sm="6"
    >
      <BlockCard
        button="Hacer copia"
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
        title="Copias de seguridad"
        icon="DatabaseIcon"
      />
    </b-col>

    <!-- Modo mantenimiento -->
    <b-col
      cols="12"
      lg="4"
      md="4"
      sm="6"
    >
      <BlockCard
        button="Configurar"
        description="Bloquea el acceso a los no administradores mostrando un aviso"
        title="Modo mantenimiento"
        icon="ToolIcon"
        @action="mantenimiento = true"
      />
    </b-col>
    <mantenimiento-config
      :show="mantenimiento"
      @closeModal="mantenimiento = false"
    />
  </b-row>
</template>

<script>
import { BCol, BRow } from 'bootstrap-vue'
import ImportarEmpleados from '@/views/system/configuracion/ImportarEmpleados.vue'
import BlockCard from '@/components/BlockCard.vue'
import MantenimientoConfig from '@/views/system/configuracion/MantenimientoConfig.vue'

export default {
  components: {
    BCol,
    BRow,

    ImportarEmpleados,
    BlockCard,
    MantenimientoConfig,
  },
  data() {
    return {
      importEmpleados: false,
      mantenimiento: false,
    }
  },
}
</script>

<style></style>
